import { Text } from "components/commons";
import { dateTimeFormatV3, formatAmount } from "utils";
import { prettifyPaymentMethod } from "utils/pretty.utils";
import styles from "../cash-noncash.module.scss";

export const keyAccountCollectionMapper = ({ val }) => {
  const {
    keyAccountCollectionId,
    dateTime,
    amount,
    siNumber,
    keyAccountName,
    paymentMethod,
    remarks,
  } = val;
  return {
    collectionId: (
      <>
        <Text className={styles.content}>{keyAccountCollectionId ?? ""}</Text>
      </>
    ),
    dateTime: (
      <>
        <Text className={styles.content}>{dateTimeFormatV3(dateTime ?? "")}</Text>
      </>
    ),
    amount: (
      <>
        <Text className={styles.content}>{formatAmount(amount ?? 0)}</Text>
      </>
    ),
    siNumSoa: (
      <>
        <Text className={styles.content}>{siNumber ?? ""}</Text>
      </>
    ),
    keyAccountName: (
      <>
        <Text className={styles.content}>{keyAccountName ?? ""}</Text>
      </>
    ),
    paymentMethod: (
      <>
        <Text className={styles.content}>{prettifyPaymentMethod(paymentMethod ?? "")}</Text>
      </>
    ),
    remarks: (
      <>
        <Text className={styles.content}>{remarks ?? "--"}</Text>
      </>
    ),
  };
};
